const linkWrapper = ({ condition, wrapper, children }) => condition ? wrapper(children) : children;
export default linkWrapper;